import React, { useState, useEffect } from 'react';
import { Drawer, Divider } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import DrawerHeader from './DrawerHeader';
import MenuList from './MenuList';
import UserSection from './DrawerFooter';

import { DrawerComponentProps, MenuItem } from './types';

const DrawerComponent: React.FC<DrawerComponentProps> = ({ open, setDrawerOpen, menuItems }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const selectedIndex = menuItems.findIndex((item) => item.url === window.location.pathname);
    setSelectedItem(selectedIndex >= 0 ? selectedIndex : null);
  }, []);

  const [selectedItem, setSelectedItem] = useState<number | null>(null);

  const [pendingNavigation, setPendingNavigation] = useState<string | null>(null);

  const handleItemClick = (item: MenuItem, index: number) => {
    setSelectedItem(index);
    setPendingNavigation(item.url || null);
    setDrawerOpen(false);
  };

  useEffect(() => {
    if (!open && pendingNavigation) {
      const timeout = setTimeout(() => {
        navigate(pendingNavigation);
        setPendingNavigation(null);
      }, 350);

      return () => clearTimeout(timeout);
    }
  }, [open, pendingNavigation, navigate]);
  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={() => setDrawerOpen(false)}
      variant="temporary"
      ModalProps={{
        keepMounted: false,
      }}
      sx={{
        '& .MuiDrawer-paper': {
          width: 300,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <DrawerHeader onClose={() => setDrawerOpen(false)} />
      <MenuList menuItems={menuItems} selectedItem={selectedItem} onItemClick={handleItemClick} />
      <Divider />
      <UserSection />
    </Drawer>
  );
};

export default DrawerComponent;
